// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navs[data-v-30ba6572]{color:var(--lms-tenant)}.my-height[data-v-30ba6572]{height:36rem}", ""]);
// Exports
module.exports = exports;
